(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var PLAY_SVG  = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M8 5v14l11-7-11-7z"/></svg>';
  var PAUSE_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';

  /* NEW: speaker icons */
  var VOL_ON_SVG  = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><rect x="3" y="8" width="4" height="8" fill="currentColor"/><polygon points="7,8 13,4 13,20 7,16" fill="currentColor"/><path d="M16 8a5 5 0 0 1 0 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var VOL_OFF_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><rect x="3" y="8" width="4" height="8" fill="currentColor"/><polygon points="7,8 13,4 13,20 7,16" fill="currentColor"/><line x1="15" y1="8" x2="21" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="21" y1="8" x2="15" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  var uid = 0;
  function nextId(){ uid += 1; return 'hero-video-' + uid; }

  function positionedAncestor(el){
    var n = el.parentElement;
    while (n && n !== document.body) {
      var s = getComputedStyle(n);
      if (s.position !== 'static') return n;
      n = n.parentElement;
    }
    return null;
  }

  function attach(video){
    if (video.dataset.a11yBtn === '1') return;
    video.dataset.a11yBtn = '1';
    if (!video.id) video.id = nextId();

    // Wrapper that holds BOTH buttons
    var wrap = document.createElement('div');
    wrap.className = 'hero__a11y-controls';
    wrap.style.position = 'absolute';
    wrap.style.right = '12px';
    wrap.style.bottom = '12px';
    wrap.style.zIndex = '2147483647';
    wrap.style.pointerEvents = 'auto';

    // PLAY/PAUSE button
    var playBtn = document.createElement('button');
    playBtn.type = 'button';
    playBtn.className = 'hero-video-toggle';
    playBtn.setAttribute('aria-controls', video.id);

    // MUTE button
    var muteBtn = document.createElement('button');
    muteBtn.type = 'button';
    muteBtn.className = 'hero-video-toggle';
    muteBtn.setAttribute('aria-controls', video.id);

    wrap.appendChild(playBtn);
    wrap.appendChild(muteBtn);

    var container = positionedAncestor(video) || video.parentElement || document.body;
    container.appendChild(wrap);

    // If container isn't positioned, fall back to fixed + track position
    if (getComputedStyle(container).position === 'static') {
      wrap.style.position = 'fixed';
      var updatePos = function(){
        var r = video.getBoundingClientRect();
        wrap.style.left = (r.right - 12 - wrap.offsetWidth) + 'px';
        wrap.style.top  = (r.bottom - 12 - wrap.offsetHeight) + 'px';
      };
      var ro = new ResizeObserver(updatePos);
      ro.observe(video);
      window.addEventListener('scroll', updatePos, { passive: true });
      window.addEventListener('resize', updatePos);
      requestAnimationFrame(updatePos);
    }

    function syncPlayIcon(){
      var playing = !video.paused && !video.ended;
      playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      playBtn.innerHTML = playing ? PAUSE_SVG : PLAY_SVG;
    }

    function syncMuteIcon(){
      var muted = !!video.muted;
      muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      muteBtn.setAttribute('aria-pressed', String(muted));
      muteBtn.innerHTML = muted ? VOL_OFF_SVG : VOL_ON_SVG;
    }

    playBtn.addEventListener('click', function(){
      if (video.paused || video.ended) video.play(); else video.pause();
    });

    muteBtn.addEventListener('click', function(){
      video.muted = !video.muted;
      syncMuteIcon();
    });

    ['play','playing','pause','ended'].forEach(function(evt){
      video.addEventListener(evt, syncPlayIcon, { passive: true });
    });

    // Respect reduced motion users
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.pause();
      }
    } catch(e){}

    // Initial sync
    syncPlayIcon();
    syncMuteIcon();
  }

  function init(scope){
    (scope || document).querySelectorAll('video.hero__video').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
